"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
exports.CanvasInnerDefault = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  outline: 1px dashed rgba(0,0,0,0.1);\n  width: 10000px;\n  height: 10000px;\n  cursor: move;\n"], ["\n  position: relative;\n  outline: 1px dashed rgba(0,0,0,0.1);\n  width: 10000px;\n  height: 10000px;\n  cursor: move;\n"])));
var templateObject_1;
//# sourceMappingURL=CanvasInner.default.js.map